import moment from 'moment'
import { identity, values } from 'lodash'
import { AIRDNA_TOOLIPS } from 'src/constants/messages'
import Format from 'src/Components/Format'

const extractValues = yearlyValues => {
  const { ltm, ...values } = yearlyValues

  return flattenYears(values)
}

const flattenYears = datapoints => {
  // Flatten into a single object with no year
  const monthlyValues = values(datapoints)
  return Object.assign({}, monthlyValues[0], monthlyValues[1])
}

const getMessageFormatter = intl => (key, amount) => {
  const message = AIRDNA_TOOLIPS[key]

  if (!message) {
    return ''
  }

  return intl.formatMessage(message, {
    amount: Format.number(amount)
  })
}

const mapForKey = (key, valueFormatter = identity) => (
  intl,
  data,
  percentage = 1
) => {
  const monthlyValues = extractValues(data[key])
  const messageFormatter = getMessageFormatter(intl)

  const datapoints = Object.keys(monthlyValues).map(month => {
    const m = moment()
      .startOf('day')
      .month(month - 1)
      .date(1)
    const value = valueFormatter(monthlyValues[month] * percentage)

    return {
      value,
      date: m.toDate(),
      tooltipEmphasis: messageFormatter(key, value),
      tooltipDescription: intl.formatMessage(AIRDNA_TOOLIPS.description, {
        month: m.format('MMM')
      })
    }
  })

  if (key !== 'occupancy') {
    return { datapoints, yFormat: 'money' }
  }

  return { datapoints }
}

export const monthlyRevenue = mapForKey('revenue', Math.round)
export const monthlyOccupancy = mapForKey('occupancy', v => Math.round(30 * v))
export const nightlyRate = mapForKey('adr', Math.round)
